import React from 'react';
import { BrowserRouter as Router, Redirect, Switch, Route, useLocation } from 'react-router-dom';
import './App.less';
import { Home } from './pages/home/Home';
import { Login } from './pages/login/Login';
import { AuthProvider, useAuth } from './features/auth/AuthContext';

const ProtectedHome: React.FC = () => {
  const auth = useAuth();
  const location = useLocation();
  if (!auth.loading && !auth.authenticated) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Redirect to={`/login?returnTo=${encodeURIComponent(returnTo)}`} />;
  }
  return <Home />;
};

function App() {
  return (
    <Router basename={process.env.REACT_APP_BASENAME}>
      <AuthProvider>
        <div className="App">
          <Switch>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/">
              <ProtectedHome />
            </Route>
          </Switch>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
